import {fromBase64, encode as encodeToBase64} from 'js-base64';
import {pack, unpack} from "jsonpack";


export const encode = <T extends {}>(data: T): string => {
  const packJSON = pack(data);
  return encodeToBase64(packJSON, true);
}
export const decode = <T extends {}>(dataStr: string): T => {
  const packJSON = fromBase64(dataStr);
  return unpack<T>(packJSON);
}
